import React from 'react';
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {accessConstants, authUtils} from "mindsets-js-sdk";

const DeleteMenuItem = function ({id}) {
    const me = useSelector(state => state.me);
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_ALL_LESSONS])) {
        return (
            <button
                className='button red mx-2 my-1'
                data-bs-toggle="modal"
                data-bs-target={'#delete-lesson-modal-' + id}
            >
                <i className='fas fa-trash'/>
            </button>
        );
    }

    return null;
}

DeleteMenuItem.propTypes = {
    id: PropTypes.number.isRequired
}

export default DeleteMenuItem;
